import Entity from "./entity";

class InvoiceDataItem extends Entity {
  constructor(data) {
    super(data);
    this.dateFrom = this.convertDate(data.dateFrom);
    this.dateTo = this.convertDate(data.dateTo);
  }
}

export default InvoiceDataItem;



// WEBPACK FOOTER //
// ./client/domain/invoiceData.js